// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCApiGatewayServiceClientsEnumsContactDatePreferenceType } from './tCApiGatewayServiceClientsEnumsContactDatePreferenceType.js';
import type { TCApiGatewayServiceClientsEnumsContactInfoPurposeType } from './tCApiGatewayServiceClientsEnumsContactInfoPurposeType.js';
import type { TCApiGatewayServiceClientsEnumsContactInfoType } from './tCApiGatewayServiceClientsEnumsContactInfoType.js';
import type { TCApiGatewayServiceClientsEnumsContactTimePreferenceType } from './tCApiGatewayServiceClientsEnumsContactTimePreferenceType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersAccountModelsSharedPhoneDataModel {
    'phoneType'?: TCApiGatewayServiceClientsEnumsContactInfoType;
    'phonePurpose'?: TCApiGatewayServiceClientsEnumsContactInfoPurposeType;
    'phoneNumber'?: string | null;
    'extension'?: string | null;
    'contactDatePreferenceType'?: TCApiGatewayServiceClientsEnumsContactDatePreferenceType;
    'bestDaysToCall'?: string | null;
    'contactTimePreferenceType'?: TCApiGatewayServiceClientsEnumsContactTimePreferenceType;
    'bestTimeToCall'?: string | null;
    'language'?: string | null;
    'timeZone'?: string | null;
    'isVoicemailOptedIn'?: boolean | null;
    'isPrimary'?: boolean | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersAccountModelsSharedPhoneDataModel>> = [
        {
            "name":     "phoneType",
            "baseName": "phoneType",
            "type":     "TCApiGatewayServiceClientsEnumsContactInfoType"
        },
        {
            "name":     "phonePurpose",
            "baseName": "phonePurpose",
            "type":     "TCApiGatewayServiceClientsEnumsContactInfoPurposeType"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "extension",
            "baseName": "extension",
            "type":     "string"
        },
        {
            "name":     "contactDatePreferenceType",
            "baseName": "contactDatePreferenceType",
            "type":     "TCApiGatewayServiceClientsEnumsContactDatePreferenceType"
        },
        {
            "name":     "bestDaysToCall",
            "baseName": "bestDaysToCall",
            "type":     "string"
        },
        {
            "name":     "contactTimePreferenceType",
            "baseName": "contactTimePreferenceType",
            "type":     "TCApiGatewayServiceClientsEnumsContactTimePreferenceType"
        },
        {
            "name":     "bestTimeToCall",
            "baseName": "bestTimeToCall",
            "type":     "string"
        },
        {
            "name":     "language",
            "baseName": "language",
            "type":     "string"
        },
        {
            "name":     "timeZone",
            "baseName": "timeZone",
            "type":     "string"
        },
        {
            "name":     "isVoicemailOptedIn",
            "baseName": "isVoicemailOptedIn",
            "type":     "boolean"
        },
        {
            "name":     "isPrimary",
            "baseName": "isPrimary",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersAccountModelsSharedPhoneDataModel.attributeTypeMap;
    }
}
